import { http } from "./http";

export default {
  // 1.登录
  login: (model) => http("get", `/user/${model.userName}/${model.password}`),

  // 2.获取产品列别
  getProductClass: (id, type) =>
    http("get", `/product/${id ? id : ""}/${type ? type : ""}`),

  // 3.添加产品
  addProduct: (model) =>
    http("post", "/product", {
      token: true,
      data: model,
    }),

  // 3.5 更新产品
  putProduct: (model) =>
    http("put", "/product", {
      token: true,
      data: model,
    }),
  // 删除产品
  deleteProduct: (model) =>
    http("delete", `/product/`, {
      data: {
        id: model.id,
        token: window.sessionStorage.getItem("token"),
      },
    }),

  // 4.新增材质
  addMaterial: (model) =>
    http("post", "/material", {
      token: true,
      data: model,
    }),

  // 4.5 更新材质
  putMaterial: (model) =>
    http("put", "/material", {
      token: true,
      data: model,
    }),

  // 5 查看材质列表
  getMaterialList: (name) => http("get", `/material/${name ? name : ""}`),

  // 5.5 查看材质详情
  seeMaterial: (mId) => http("get", `/material/${mId}`),
  // 删除材质
  deleteMaterial: (model) =>
    http("delete", "/material", {
      data: {
        id: model.id,
        token: window.sessionStorage.getItem("token"),
      },
    }),

  // 6.创建炉号
  createFurnaceNo: (model) =>
    http("post", "/smelter", {
      data: {
        token: window.sessionStorage.getItem("token"),
        type: 0,
        data: model,
      },
    }),

  // 查询炉号条件
  queryFurnaceNoPc: (model) =>
    http("post", "/smelter", {
      data: {
        token: window.sessionStorage.getItem("token"),
        type: 1,
        data: model,
      },
    }),

  // 7.更新炉号
  putFurnaceNo: (model) =>
    http("put", "/smelter", {
      token: true,
      data: model,
    }),

  // 7.5 查询炉号列表
  getFurnaceNo: (model) =>
    http("get", "/smelter", {
      data: model,
    }),

  // 8.查询缺陷
  getDefect: (DefectName) =>
    http("get", `/defect/${DefectName ? DefectName : ""}`),

  // 9.添加缺陷
  addDefect: (model) =>
    http("post", "/defect", {
      token: true,
      data: model,
    }),

  // 10.更新缺陷
  putDefect: (model) =>
    http("put", "/defect", {
      token: true,
      data: model,
    }),

  // 删除材质
  deleteDefect: (model) =>
    http("delete", "/defect", {
      data: {
        id: model.id,
        token: window.sessionStorage.getItem("token"),
      },
    }),

  // 11.添加炉号化学成分
  addChemicalComposition: (model) =>
    http("post", "/smelterelement", {
      token: true,
      data: model,
    }),
  // 11.5.查看炉号化学成分
  viewChemicalComposition: (id) => http("get", `/smelterelement/${id}`),
  // 更新炉号化学成分
  putChemicalComposition: (model) =>
    http("put", "/smelterelement", {
      token: true,
      data: model,
    }),

  // 12.添加炉号力学性能
  addMechanics: (module) =>
    http("post", "/smeltermechproperty", {
      token: true,
      data: module,
    }),
  // 更新炉号力学性能
  putMechanics: (module) =>
    http("put", "/smeltermechproperty", {
      token: true,
      data: module,
    }),
  // 12.5 查看炉号力学性能
  viewMechanics: (id) => http("get", `/smeltermechproperty/${id}`),

  // 13.添加报废
  addScrap: (module) =>
    http("post", "/scrap", {
      token: true,
      type: 0,
      data: module,
    }),

  // 13.5 查询报废
  queryScrap: (id) => http("get", `/scrap`),
  // 13.10 按条件查询报废
  qbcScrap: (module) =>
    http("post", "/scrap", {
      data: {
        token: window.sessionStorage.getItem("token"),
        type: 1,
        data: module,
      },
    }),

  // 14.添加金相结果
  addMetallographic: (module) =>
    http("post", "/metallogra", {
      token: true,
      data: module,
    }),
  // 更新金相结果
  putMetallographic: (module) =>
    http("put", "/metallogra", {
      token: true,
      data: module,
    }),
  // 15.金相结果
  ViewMetallographic: (sid) => http("get", `/metallogra/${sid}`),

  // 15.更新炉号
  putFurnaceNo: (module) =>
    http("put", "/smelter", {
      token: true,
      data: module,
    }),
  // 删除材质
  deleteFurnaceNo: (model) =>
    http("delete", "/smelter", {
      data: {
        data: {
          sId: model.sId,
        },
        token: window.sessionStorage.getItem("token"),
      },
    }),

  // 16.pad 查询产品生产日期
  queryFurnaceData: (model) =>
    http(
      "get",
      `/checkproduct/${model.productName ? model.productName : ""}`,
      {}
    ),

  // 16.pad 查询产品炉号
  queryFurnaceNo: (model) =>
    http(
      "get",
      `/checkproduct/${model.productDate}/${model.productNumber}/${model.productName}`,
      {}
    ),

  // 17.pad 提交缺陷
  submitCheckproduct: (model) =>
    http("post", "/checkproduct", {
      token: true,
      data: model,
    }),

  // 18.查询炉号已提交交验产品编号
  querySubmitCheck: (productSn) => http("get", `/submit/${productSn}`),

  // 19.提交交验
  submitCheck: (model) =>
    http("post", "/submit", {
      data: {
        token: window.sessionStorage.getItem("token"),
        type: 0,
        data: model,
      },
    }),

  // 20.查询交交验信息
  getSubmitCheck: (model) =>
    http("post", "/submit", {
      data: {
        token: window.sessionStorage.getItem("token"),
        type: 1,
        data: model,
      },
    }),

  // 21.查询炉号探伤数据
  getSmelterCal: (model) =>
    http(
      "get",
      `/SmelterCal/${model.sId}/${model.pageSize}/${model.currentPage}`
    ),

  // 22.炉号探伤数据总览接口
  furnaceDataOverview: (sId) =>
    http("get", `/firstcheck/${window.sessionStorage.getItem("token")}/${sId}`),

  // 23.炉号探伤数据统计接口
  furnaceStatistics: (model) =>
    http("post", "/SmelterCheckOverview", {
      token: true,
      data: model,
    }),

  // 24.添加缺陷大类
  addDefectsClass: (model) =>
    http("post", "/DefectType", {
      // token: true,
      // data: model,
      data: {
        token: window.sessionStorage.getItem("token"),
        data: model,
      },
    }),

  // 25.删除缺陷大类
  dleDefectsClass: (id) =>
    http("delete", "/DefectType", {
      data: {
        token: window.sessionStorage.getItem("token"),
        id: id,
      },
    }),

  // 26.查询缺陷大类
  getDefectClass: () => http("get", "DefectType"),

  // 27.添加用户
  addUser: (model) =>
    http("post", "/user", {
      token: true,
      data: model,
    }),

  // 28.更新密码
  changePad: (model) =>
    http("put", "/user", {
      token: true,
      data: model,
    }),

  // 29.获取用户列表接口
  getUserList: () =>
    http("get", `/user/${window.sessionStorage.getItem("token")}`),

  // 30.探伤日报接口
  getDailyInspection: () => http('get', 'dailyreport')
};
